export default __webpack_public_path__ + "static/og-logo-b57ff04f7fdfae67892cc4e1461e3cad.png";